import { defineStore } from "pinia";
import { ref } from "vue";

export const useBreadcrumb = defineStore("breadcrumb", () => {
  const customBreadcrumb = ref(null);

  const setBreadcrumb = (breadcrumb) => {
    customBreadcrumb.value = breadcrumb;
  };

  const clearBreadcrumb = () => {
    customBreadcrumb.value = null;
  };

  return {
    customBreadcrumb,
    setBreadcrumb,
    clearBreadcrumb,
  };
});
